import React, { useState, useMemo } from "react";
import { Toaster } from "sonner";
import TaskPanel from "./TaskPanel";
import MapPanel from "./MapPanel";
import AgentPanel from "./AgentPanel";
import SendNotificationModal from "../../Driver/SendNotificationModal";
import TaskDetailsModal from "../MapDashBoard/TaskDetailsModal";
import AssignModal from "../AssignModal";
import DriverConfigModal from "../../Driver/DriverConfigModal";
import EditDriverModal from "../../Driver/EditDriverModal";
import DriverDetailsModal from "../../Driver/DriverDetailsModal";

export default function MapDashboardOld(props) {
  const {
    tasks,
    agents,
    teams,
    isLoading,
    setFromDate,
    setToDate,
    fetchTaskLogs,
    fetchDrivers,
    sendNotification,
    handleChangeStatus,
    editDriverApi,
    updateDriverDutyApi,
     toggleDutyStatus,
    fetchDriverConfigByCode,
    fetchSingleDriverConfig,
    saveSingleDriverConfig,
    deleteDriverConfig,
    SyncWithAnlook,
    AssignTaskToDriver,
    handleToggle,
    isChecked,
    baseurl,
    token,
    setIsUnauthorised,
    fetchCustomerInstructions,
    instructionTaskIds,
    FetchTaskCall,
  } = props;

  const getToday = () => new Date().toISOString().split("T")[0];
  const [tempFromDate, setTempFromDate] = useState(
    props.fromDate || getToday(),
  );

  const [selectedDriver, setSelectedDriver] = useState(null);
  const [showDriverDetailsModal, setShowDriverDetailsModal] = useState(false);

  const [editDriverModalOpen, setEditDriverModalOpen] = useState(false);
  const [editDriver, setEditDriver] = useState(null);

  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [configDriverCode, setConfigDriverCode] = useState("");

  const [tempToDate, setTempToDate] = useState(props.toDate || getToday());
  const [selectedTaskTab, setSelectedTaskTab] = useState("unassigned");
  const [selectedAgentTab, setSelectedAgentTab] = useState("active");
  const [searchQuery, setSearchQuery] = useState("");

  const [showAssignModal, setShowAssignModal] = useState(false);
  const [taskToAssign, setTaskToAssign] = useState(null);
  const [selectedAgentId, setSelectedAgentId] = useState("");

  const [selectedTask, setSelectedTask] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [notificationAgent, setNotificationAgent] = useState(null);

  const [assignmentLogs, setAssignmentLogs] = useState([]);
  const [statusChangeLogs, setStatusChangeLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);

  const [instructionModalOpen, setInstructionModalOpen] = useState(false);
  const [taskInstructions, setTaskInstructions] = useState([]);
  const [loadingInst, setLoadingInst] = useState(false);

  const [assignTab, setAssignTab] = useState("all");
  const [selectedAssignTeam, setSelectedAssignTeam] = useState("");

  const handleAssignTask = async () => {
    if (!selectedAgentId || !taskToAssign) return;

    const taskId =
      taskToAssign?.pk_task_id ||
      taskToAssign?.taskId ||
      taskToAssign?.task_id ||
      taskToAssign?.id;

    const oldDriverId =
      taskToAssign?.driver_id ||
      taskToAssign?.driverId ||
      taskToAssign?.driver_id_fk ||
      "0";

    if (!taskId) return;

    try {
      const unassignSuccess = await handleChangeStatus(
        taskId,
        "unassigned",
        oldDriverId,
      );

      if (!unassignSuccess) return;

      const assignSuccess = await AssignTaskToDriver(taskId, selectedAgentId);

      if (assignSuccess) {
        setShowAssignModal(false);
        setSelectedAgentId("");
        setTaskToAssign(null);

        setAssignmentLogs([]);
        setStatusChangeLogs([]);
        setShowLogs(false);

        FetchTaskCall?.();
      }
    } catch (error) {
      console.error("Old dashboard assign flow error:", error);
    }
  };

  const handleInstructionClick = async (taskId) => {
    setLoadingInst(true);

    const allData = await fetchCustomerInstructions();

    const onlyThisTask = (allData || []).filter(
      (i) => String(i.task_id) === String(taskId),
    );

    setTaskInstructions(onlyThisTask);
    setInstructionModalOpen(true);
    setLoadingInst(false);
  };

  // ---------- FILTER TASKS  ----------
  const filteredTasks = useMemo(() => {
    if (!tasks) return [];

    if (selectedTaskTab === "unassigned") {
      return tasks.filter((task) => task.status === "unassigned");
    }

    if (selectedTaskTab === "successful") {
      return tasks.filter((task) => task.status === "successful");
    }

    return tasks.filter(
      (task) => !["unassigned", "successful"].includes(task.status),
    );
  }, [tasks, selectedTaskTab]);

  // ---------- FILTER AGENTS ----------
  const filteredAgents = useMemo(() => {
    let list =
      selectedAgentTab === "total"
        ? agents
        : agents.filter(
            (a) => a.dutyStatus?.toLowerCase() === selectedAgentTab,
          );

    return list.filter((a) =>
      a.fullName?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  }, [agents, selectedAgentTab, searchQuery]);

  const handleModalDutyToggle = async (driverObj, isCurrentlyOn) => {
  if (!driverObj || typeof toggleDutyStatus !== "function") return;

  await toggleDutyStatus(driverObj, isCurrentlyOn);

  const updatedDrivers = await fetchDrivers?.(true);

  if (Array.isArray(updatedDrivers)) {
    const updatedDriver = updatedDrivers.find(
      (d) =>
        d.driverId === driverObj.driverId ||
        d.driverId === driverObj.driver_code ||
        d.driver_code === driverObj.driverId
    );

    if (updatedDriver) {
      setSelectedDriver(updatedDriver);
      return;
    }
  }

  setSelectedDriver((prev) =>
    prev
      ? {
          ...prev,
          dutyStatus: isCurrentlyOn ? "offline" : "active",
        }
      : prev
  );
};

  const handleOpenTaskDetails = (task) => {
    setSelectedTask(task);
    setShowDetailsModal(true);

    setAssignmentLogs([]);
    setStatusChangeLogs([]);
    setShowLogs(false);
  };

  const handleAssignContext = (task) => {
    setTaskToAssign(task);
    setSelectedAgentId("");
    setAssignTab("all");
    setSelectedAssignTeam("");
    setShowAssignModal(true);
  };

  const teamDrivers = useMemo(() => {
    if (!selectedAssignTeam) return agents || [];

    const teamData = (teams || []).find(
      (team) => team.team_name === selectedAssignTeam,
    );

    const ids =
      teamData?.driverlist?.map((driver) => driver.id?.toString()) || [];

    return (agents || []).filter(
      (agent) =>
        ids.includes(agent?.id?.toString()) ||
        ids.includes(agent?.driverId?.toString()),
    );
  }, [selectedAssignTeam, teams, agents]);

  const allTeamDrivers = useMemo(() => {
    if (!selectedAssignTeam) return agents || [];

    const teamData = (teams || []).find(
      (team) => team.team_name === selectedAssignTeam,
    );

    const ids =
      teamData?.driverlist?.map((driver) => driver.id?.toString()) || [];

    return (agents || []).filter(
      (agent) =>
        ids.includes(agent?.id?.toString()) ||
        ids.includes(agent?.driverId?.toString()),
    );
  }, [selectedAssignTeam, teams, agents]);

  return (
    <div className="flex w-full h-full overflow-hidden">
      <Toaster position="top-right" />

      {/* LEFT PANEL */}

      <TaskPanel
        tasks={tasks}
        filteredTasks={filteredTasks}
        isLoading={isLoading}
        selectedTaskTab={selectedTaskTab}
        setSelectedTaskTab={setSelectedTaskTab}
        setTaskToAssign={setTaskToAssign}
        setShowAssignModal={setShowAssignModal}
        onAssignClick={handleAssignContext}
        setSelectedTask={handleOpenTaskDetails}
        setShowDetailsModal={setShowDetailsModal}
        SyncWithAnlook={SyncWithAnlook}
        setFromDate={setFromDate}
        setToDate={setToDate}
        handleToggle={handleToggle}
        isChecked={isChecked}
        onInstructionClick={handleInstructionClick}
        instructionTaskIds={instructionTaskIds}
        tempFromDate={tempFromDate}
        tempToDate={tempToDate}
        setTempFromDate={setTempFromDate}
        setTempToDate={setTempToDate}
        FetchTaskCall={() => {
          if (props.fetchTasks) {
            props.fetchTasks(tempFromDate, tempToDate, props.setTasks);
            props.setFromDate(tempFromDate);
            props.setToDate(tempToDate);
          }
        }}
      />

      {/* MIDDLE MAP */}
      <MapPanel tasks={tasks} agents={agents} />

      {/* RIGHT AGENTS */}
      <AgentPanel
        agents={agents}
        filteredAgents={filteredAgents}
        selectedAgentTab={selectedAgentTab}
        setSelectedAgentTab={setSelectedAgentTab}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        fetchDrivers={fetchDrivers}
        setNotificationAgent={setNotificationAgent}
        setNotificationModalOpen={setNotificationModalOpen}
        onDriverClick={(agent) => {
          setSelectedDriver(agent);
          setShowDriverDetailsModal(true);
        }}
      />

      {/* ASSIGN DRIVER MODAL */}

      <AssignModal
        show={showAssignModal && !!taskToAssign}
        onClose={() => {
          setShowAssignModal(false);
          setSelectedAgentId("");
          setTaskToAssign(null);
        }}
        teams={teams || []}
        assignTab={assignTab}
        setAssignTab={setAssignTab}
        selectedAssignTeam={selectedAssignTeam}
        setSelectedAssignTeam={setSelectedAssignTeam}
        teamDrivers={teamDrivers}
        allTeamDrivers={allTeamDrivers}
        selectedAgentId={selectedAgentId}
        setSelectedAgentId={setSelectedAgentId}
        handleAssignTask={handleAssignTask}
      />

      {/* TASK DETAILS MODAL */}
      {showDetailsModal && (
        <TaskDetailsModal
          show={showDetailsModal}
          task={selectedTask}
          onClose={() => setShowDetailsModal(false)}
          assignmentLogs={assignmentLogs}
          statusChangeLogs={statusChangeLogs}
          showLogs={showLogs}
          setShowLogs={setShowLogs}
          onFetchLogs={async (taskId) => {
            const data = await fetchTaskLogs(taskId);

            setAssignmentLogs(data?.assignmentLogs || []);
            setStatusChangeLogs(data?.statusChangeLogs || []);
          }}
          onStatusChange={async (taskId, newStatus) => {
            const success = await handleChangeStatus(
              taskId,
              newStatus,
              selectedTask?.driver_id,
            );

            if (success) {
              setShowDetailsModal(false);
            }
          }}
          onUnassignRequest={(task) => {
            setShowDetailsModal(false);
            setSelectedTask(null);

            setTimeout(() => {
              handleAssignContext(task);
            }, 0);
          }}
        />
      )}

      {instructionModalOpen && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white p-5 rounded-xl w-[520px] shadow-lg">
            <h2 className="text-lg font-bold mb-3">Customer Instructions</h2>

            {loadingInst ? (
              <p>Loading...</p>
            ) : Array.isArray(taskInstructions) &&
              taskInstructions.length > 0 ? (
              taskInstructions.map((i) => (
                <div
                  key={i.pk_customer_delivery_instruction_id}
                  className="mb-3 border-b pb-3"
                >
                  <p className="font-semibold text-base">
                    {i.instuction_title || "Instruction"}
                  </p>

                  <p className="text-sm text-gray-600 mt-1">
                    <strong>Default note:</strong>{" "}
                    {i.instuction_description || "No description"}
                  </p>

                  {i.customer_instruction_messege && (
                    <p className="text-sm text-orange-700 mt-1">
                      <strong>Customer message:</strong>{" "}
                      {i.customer_instruction_messege}
                    </p>
                  )}

                  <p className="text-xs text-gray-600 mt-1">
                    Shop: {i.shop_name || "N/A"} • Task: {i.task_id}
                  </p>
                </div>
              ))
            ) : (
              <p className="text-gray-500">No instructions for this task.</p>
            )}

            <div className="mt-3 flex justify-end">
              <button
                onClick={() => {
                  setInstructionModalOpen(false);
                  setTaskInstructions([]);
                }}
                className="bg-red-500 text-white px-4 py-2 rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* SEND NOTIFICATION */}
      <SendNotificationModal
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
        driver={notificationAgent}
        baseurl={baseurl}
        token={token}
        setIsUnauthorised={setIsUnauthorised}
        sendSingleNotificationApi={sendNotification}
      />

      <DriverDetailsModal
        open={showDriverDetailsModal}
        onOpenChange={setShowDriverDetailsModal}
        driver={selectedDriver}
        fetchDriverConfigByCode={fetchDriverConfigByCode}
        onOpenConfig={(driverCode) => {
          setConfigDriverCode(driverCode);
          setConfigModalOpen(true);
        }}
        onEditDriver={(driverObj) => {
          setShowDriverDetailsModal(false);
          setEditDriver(driverObj);
          setEditDriverModalOpen(true);
        }}
         onToggleDutyStatus={handleModalDutyToggle}
  dutyLoading={props.loading}
      />

      <EditDriverModal
        isOpen={editDriverModalOpen}
        onClose={() => setEditDriverModalOpen(false)}
        driver={editDriver}
        teams={teams}
        onDriverUpdated={() => {
          if (typeof fetchDrivers === "function") {
            fetchDrivers(true);
          }
        }}
        editDriverApi={editDriverApi}
        updateDriverDutyApi={updateDriverDutyApi}
      />

      <DriverConfigModal
        open={configModalOpen}
        onOpenChange={setConfigModalOpen}
        driverCode={configDriverCode}
        onSuccess={() => {
          if (typeof fetchDrivers === "function") {
            fetchDrivers(true);
          }
        }}
        fetchSingleDriverConfig={fetchSingleDriverConfig}
        saveSingleDriverConfig={saveSingleDriverConfig}
        deleteSingleDriverConfig={deleteDriverConfig}
      />
    </div>
  );
}
